import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './images/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-7d6b4baa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fast-view-panel" }
const _hoisted_2 = { class: "fast-view-panel__content" }
const _hoisted_3 = { class: "fast-view-panel__image-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "fast-view-panel__product-info product-info"
}
const _hoisted_6 = {
  key: 0,
  class: "cooking-warning"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cooking-warning__icon",
  src: _imports_0
}, null, -1))
const _hoisted_8 = { class: "cooking-warning__text" }
const _hoisted_9 = { class: "product-info__name" }
const _hoisted_10 = {
  key: 1,
  class: "product-info__weight"
}
const _hoisted_11 = { class: "product-info__prices-and-stocks" }
const _hoisted_12 = { class: "prices" }
const _hoisted_13 = { class: "current-price rouble-symbol" }
const _hoisted_14 = {
  key: 1,
  class: "old-price rouble-symbol"
}
const _hoisted_15 = { class: "product-info__stocks stocks" }
const _hoisted_16 = {
  key: 0,
  class: "stocks__is-new"
}
const _hoisted_17 = {
  key: 1,
  class: "stocks__discount"
}
const _hoisted_18 = {
  key: 2,
  class: "option-controls"
}
const _hoisted_19 = { class: "controls" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "add-btn__title" }, "Добавить", -1))
const _hoisted_21 = { class: "add-btn__price rouble-symbol" }
const _hoisted_22 = {
  key: 3,
  class: "product-info__structure structure"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "structure__title" }, "Состав:", -1))
const _hoisted_24 = { class: "structure__description" }
const _hoisted_25 = {
  key: 4,
  class: "product-info__nutritional-value nutritional-value"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nutritional-value__title" }, "Пищевая ценность на 100 г:", -1))
const _hoisted_27 = {
  key: 0,
  class: "nutritional-value__row"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Белки", -1))
const _hoisted_29 = {
  key: 1,
  class: "nutritional-value__row"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Жиры", -1))
const _hoisted_31 = {
  key: 2,
  class: "nutritional-value__row"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Углеводы", -1))
const _hoisted_33 = {
  key: 3,
  class: "nutritional-value__row"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Энергетическая ценность", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FinalPricePanel = _resolveComponent("FinalPricePanel")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_QuantityControl = _resolveComponent("QuantityControl")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.product.image
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.selectedOption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.selectedOption.cookingTime)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, " Только по предварительному заказу за " + _toDisplayString(_ctx.selectedOption.cookingTime) + " ч. ", 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.product.name), 1),
            (_ctx.isSingleOption && _ctx.selectedOption.weight)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.selectedOption.weight) + " г ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.price)), 1),
                (_ctx.selectedOption.hasStopPrice)
                  ? (_openBlock(), _createBlock(_component_FinalPricePanel, {
                      key: 0,
                      class: "final-price",
                      "with-title": true,
                      "with-panel-title": true
                    }))
                  : _createCommentVNode("", true),
                (_ctx.selectedOption.price !== _ctx.selectedOption.priceWithoutDiscount)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.priceWithoutDiscount)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                (_ctx.product.isNew)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                  : (_ctx.selectedOption.discountPercent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.selectedOption.discountPercent), 1))
                    : _createCommentVNode("", true)
              ])
            ]),
            (!_ctx.isSingleOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.selectedOption)
                    ? (_openBlock(), _createBlock(_component_SelectField, {
                        key: 0,
                        class: "option-controls__options",
                        items: _ctx.modifyOptionsForSelect,
                        "selected-key": _ctx.selectedOption.id,
                        onSelect: _ctx.selectOption
                      }, null, 8, ["items", "selected-key", "onSelect"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_QuantityControl, {
                    class: "option-controls__quantity",
                    quantity: _ctx.quantity,
                    "is-block-decrease-control": true,
                    onIncrease: _ctx.increase,
                    onDecrease: _ctx.decrease
                  }, null, 8, ["quantity", "onIncrease", "onDecrease"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                style: _normalizeStyle({ display: _ctx.isSingleOption ? 'block' : 'none' }),
                class: "controls__quantity-control"
              }, [
                _createVNode(_component_QuantityControl, {
                  quantity: _ctx.quantity,
                  "is-block-decrease-control": true,
                  onIncrease: _ctx.increase,
                  onDecrease: _ctx.decrease
                }, null, 8, ["quantity", "onIncrease", "onDecrease"])
              ], 4),
              _createElementVNode("div", {
                class: "controls__add-btn add-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
              }, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.totalPrice)), 1)
              ])
            ]),
            (_ctx.selectedOption.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$filters.replacedHtmlTags(_ctx.selectedOption.description)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isShowNutricionalValues)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _hoisted_26,
                  (_ctx.selectedOption.protein)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.protein, 1)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedOption.fat)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.fat, 1)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedOption.carbohydrate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.carbohydrate, 1)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedOption.calories)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.selectedOption.calories, 1)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}